import { useClassified } from "@/contexts/classified";
import { useTrackingEvent } from "./useTrackingEvent";
export const useTrackingNavigationBar = () => {
    var _a, _b, _c;
    const { av_distribution_type_global, av_estate_type_global, av_client_type, av_items, } = (_b = (_a = useClassified()) === null || _a === void 0 ? void 0 : _a.tracking) !== null && _b !== void 0 ? _b : {};
    const av_client_id = (_c = av_items === null || av_items === void 0 ? void 0 : av_items[0]) === null || _c === void 0 ? void 0 : _c.client_id;
    const EVENT_DATA = {
        event: "navigation_bar_clicks",
        av_distribution_type_global,
        av_estate_type_global,
        av_client_type,
        av_client_id,
    };
    return useTrackingEvent(EVENT_DATA);
};
